import React, { Component } from 'react';
import Login from './Login.js';
import { Collapse } from 'react-bootstrap';
import Top from './Top.js';
import Navbar from './Navbar.js';
import createHistory from 'history/createBrowserHistory'
import ReactDOM from 'react-dom';
import './styles/index.css';
import { get } from './util/Utility';
import AlertContainer from 'react-alert';
import { MdCheckCircle, MdCancel, MdWarning } from 'react-icons/lib/md';
import Raven from 'raven-js';

import Rebase from 're-base';
import firebase from 'firebase';
firebase.initializeApp({
  apiKey: "AIzaSyDoSWDoN2e2x2ViaRKUQ2D4WRWCXOPtgmw",
  authDomain: "ccoapp.firebaseapp.com",
  databaseURL: "https://ccoapp.firebaseio.com",
  storageBucket: "ccoapp.appspot.com",
  messagingSenderId: "273690147929"
});
window.base = Rebase.createClass(firebase.database());
window.firebase = firebase;

Raven.config('https://3cf84efe13e74d50a555b5e111fff004@sentry.io/234126').install()

window.leaderNameStash = {};
window.ministryNameStash = {};

window.historyObj = createHistory();

var newestFirst = function(a, b) { return b.date - a.date};
var oldestFirst = function(a, b) { return a.date - b.date};

window.sortForType = function(type) {
  switch (type) {
    case "event": return oldestFirst;
    default: return newestFirst;
  }
}

String.prototype.capitalizeFirstLetter = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
}

Array.prototype.toCSV = function(format) {
  var returnStr = '';

  var formatFunc = format || function(item) { return item }

  if (this.length > 0) {
    this.forEach(function(item, i, arr) {
      //console.log(item);
      returnStr += formatFunc(item) + (i + 1 === arr.length ? "" : ", ");
    });
  }
  return returnStr;
}

// Object.prototype.toCSV = function(format) {
//   var returnStr = '';
//
//   var formatFunc = format || function(item) { return item }
//
//   if (this.length > 0) {
//     Object.values(this).forEach(function(item, i, arr) {
//       //console.log(item);
//       returnStr += formatFunc(item) + (i + 1 === arr.length ? "" : ", ");
//     });
//   }
//   return returnStr;
// }

String.prototype.hashCode = function() {
  var hash = 0, i, chr;
  if (this.length === 0) return hash;
  for (i = 0; i < this.length; i++) {
    chr   = this.charCodeAt(i);
    hash  = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      user: null,
      mobile: screen.width < 500
    };

    get('leaders', this).then(leaders => {
      leaders.forEach(leader => {
        window.leaderNameStash[leader.key] = leader.name;
      })
    });

    window.base.listenTo('sermon_collections', {
      context: this,
      asArray: false,
      then(data) {
        delete data.featured;
        window.sermon_collections = data;
      }
    })

    // Listen to authentication
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        Raven.setUserContext({
          email: user.email,
          id: user.uid
        })
        console.log("User " + user.uid + " is logged in with " + user.providerId);
        this.setState({user: user});
      } else {
        Raven.setUserContext(null)
        console.log("User is logged out");
        this.setState({user: null});
      }
    });



    window.show = (type, title, message) => {
      let icon = null;
      switch (type) {
        case 'success': icon = <MdCheckCircle size={30} color='green' />; break;
        case 'error': icon = <MdCancel size={30} color='red' />; break;
        case 'warn': icon = <MdWarning size={30} color='yellow' />; break;
      }

      this.msg.show(<div>
        <h5>{title}</h5>
        <p>{message}</p>
      </div>, {icon})
    }

  }

  updateDimensions() {
    this.setState({width: window.innerWidth, height: window.innerHeight});
    if ((window.innerWidth < 650 || screen.width < 600) && this.state.mobile === false) {
      this.setState({mobile: true});
    }
    else if ((window.innerWidth >= 650) && this.state.mobile === true) {
      this.setState({mobile: false});
    }
  }

  componentWillMount() {
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  componentDidMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  render() {

    var divStyle = {
      position: 'absolute',
      top: 0,
      right: 0,
      left: 0,
      bottom: 0
    }

    let alertOptions = {
      offset: 14,
      position: 'top right',
      theme: 'light',
      time: 8000,
      transition: 'scale'
    }

    return (
      <div style={divStyle}>
        {this.state.user !== null && this.state.user.emailVerified && <div style={divStyle}>
          <div style={divStyle}>
            <Top user={this.state.user} mobile={this.state.mobile}/>
            <Navbar user={this.state.user} mobile={this.state.mobile}/>
          </div>
        </div>}

        <Collapse in={this.state.user === null || !this.state.user.emailVerified}>
          <div style={divStyle}>
            <Login in={this.state.user === null || !this.state.user.emailVerified} mobile={this.state.mobile} user={this.state.user} setUser={user => this.setState({user})} />
          </div>
        </Collapse>

        <AlertContainer ref={a => this.msg = a} {...alertOptions} />
      </div>
    );
  }
}

ReactDOM.render(
  <App />,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/